export const GET_IDV_PAGE_START = 'GET_IDV_PAGE_START';
export const GET_IDV_PAGE_SUCCESS = 'GET_IDV_PAGE_SUCCESS';
export const GET_IDV_PAGE_FAIL = 'GET_IDV_PAGE_FAIL';

export const GET_IDV_DOCUMENTS_START = 'GET_IDV_DOCUMENTS_START';
export const GET_IDV_DOCUMENTS_SUCCESS = 'GET_IDV_DOCUMENTS_SUCCESS';
export const GET_IDV_DOCUMENTS_FAIL = 'GET_IDV_DOCUMENTS_FAIL';
export const RESET_IDV_DOCUMENTS = 'RESET_IDV_DOCUMENTS';

export const VERIFY_DOCUMENTS_START = 'VERIFY_DOCUMENTS_START';
export const VERIFY_DOCUMENTS_SUCCESS = 'VERIFY_DOCUMENTS_SUCCESS';
export const VERIFY_DOCUMENTS_FAIL = 'VERIFY_DOCUMENTS_FAIL';

export const SET_ALL_IDV_DATA_FETCHED = 'SET_ALL_IDV_DATA_FETCHED';
export const SET_SELECTED_COUNTRY = 'SET_SELECTED_COUNTRY';

export const LIVENESS_CHECK_START = 'LIVENESS_CHECK_START';
export const LIVENESS_CHECK_SUCCESS = 'LIVENESS_CHECK_SUCCESS';
export const LIVENESS_CHECK_FAIL = 'LIVENESS_CHECK_FAIL';

export const VERIFY_SECUREME_FLOW_START = 'VERIFY_SECUREME_FLOW_START';
export const VERIFY_SECUREME_FLOW_SUCCESS = 'VERIFY_SECUREME_FLOW_SUCCESS';
export const VERIFY_SECUREME_FLOW_FAIL = 'VERIFY_SECUREME_FLOW_FAIL';
